import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconChevronDoubleRight';
/** Renders an SVG icon. */
const SvgChevronDoubleRight = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M8.204 9.796a1.126 1.126 0 0 1 1.592-1.592l7 7c.44.44.44 1.152 0 1.592l-7 7a1.126 1.126 0 0 1-1.592-1.592L14.408 16z"
      />
      <path
        fill="currentColor"
        d="M16.204 9.796a1.126 1.126 0 0 1 1.592-1.592l7 7c.44.44.44 1.152 0 1.592l-7 7a1.126 1.126 0 0 1-1.592-1.592L22.408 16z"
      />
    </svg>
  );
};
SvgChevronDoubleRight.displayName = displayName;
export default SvgChevronDoubleRight;
